(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  /*
   * A frame-aware start to the message. Product pages link here with ?frame= and
   * ?frame_url=; if the message box is still empty, the frame's name and address go
   * into it so the shop knows exactly which piece the question is about. A message
   * the shopper has already typed - or one re-rendered after a failed submit - is
   * never overwritten.
   */
  (() => {
    const params = new URLSearchParams(window.location.search);
    const frame = params.get('frame');
    if (!frame) return;
    const box = document.querySelector('.contact textarea[name="contact[body]"]');
    if (!box || box.value.trim()) return;
    const path = params.get('frame_url') || '';
    const safePath = path.startsWith('/products/') ? path : '';
    const link = safePath ? `\n${window.location.origin}${safePath}` : '';
    box.value = `About: ${frame.slice(0, 200)}${link}\n\n`;
  })();

  } catch(e) { console.error(e); }
})();
})();
